import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: theme.spacing(2),
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  header: {
    marginBottom: '30px',
    flexShrink: 0,
  },
  alert: {
    marginBottom: 10,
    flexShrink: 0,
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
  grid: {
    flex: 1,
    minHeight: 0,
  },
  gridItem: {
    display: 'flex',
    minHeight: 0,
  },
  background: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  tableModeText: {
    fontSize: '0.72rem',
    color: theme.palette.custom.secondary2,
    marginBottom: theme.spacing(0.75),
    flexShrink: 0,
  },
  tableModeLink: {
    fontSize: '0.72rem',
    color: theme.palette.custom.primary1,
    textDecoration: 'underline',
  },
  dataGrid: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none',
    },
  },
}));
